import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledComparisonChart,
  Container,
  Header,
  Content,
  ChartBrands,
  BrandsWrapper,
  Brand,
  LogoImg,
  ChartItems,
} from './styles.js';
import logo from './ollie-logo.svg';
import { ComparisonChartItem } from './ComparisonChartItem';

export const ComparisonChart = ({
  header,
  background = 'background.base',
  competitorLabel,
  rows,
}) => {
  return (
    <StyledComparisonChart background={background}>
      <Container>
        <Header>{header}</Header>
        <Content>
          <ChartBrands>
            <BrandsWrapper>
              <Brand>{competitorLabel}</Brand>
              <LogoImg src={logo.src} alt="Ollie logo" />
            </BrandsWrapper>
          </ChartBrands>
          <ChartItems>
            {rows.map((feature, i) => (
              <ComparisonChartItem
                key={i}
                header={feature.header}
                subheader={feature.subheader}
              />
            ))}
          </ChartItems>
        </Content>
      </Container>
    </StyledComparisonChart>
  );
};

ComparisonChart.displayName = 'ComparisonChart';

ComparisonChart.propTypes = {
  header: PropTypes.string.isRequired,
  background: PropTypes.string,
  competitorLabel: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      subheader: PropTypes.string,
    }),
  ).isRequired,
};
